"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitRecipeFeedback = exports.setRecipeNote = exports.unfavouriteRecipe = exports.favouriteRecipeVariant = exports.bulkFavouriteRecipeVariants = void 0;
function bulkFavouriteRecipeVariants(client, opts) {
    return client.post('bulk_favourite_recipe_variants', {
        ids: opts.ids
    });
}
exports.bulkFavouriteRecipeVariants = bulkFavouriteRecipeVariants;
function favouriteRecipeVariant(client, opts) {
    return client.post('favourite_recipe_variant', {
        id: opts.id
    });
}
exports.favouriteRecipeVariant = favouriteRecipeVariant;
function unfavouriteRecipe(client, opts) {
    return client.post('unfavourite_recipe', { id: opts.id });
}
exports.unfavouriteRecipe = unfavouriteRecipe;
function setRecipeNote(client, opts) {
    return client.post('set_recipe_note', {
        recipe_id: opts.recipeId,
        body: opts.body
    });
}
exports.setRecipeNote = setRecipeNote;
function submitRecipeFeedback(client, opts) {
    return client.post('submit_recipe_feedback', opts.feedback);
}
exports.submitRecipeFeedback = submitRecipeFeedback;
